import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SacredGeometry from '../components/SacredGeometry';
import AnimatedBackground from '../components/AnimatedBackground';

const Tarifs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const prestations = [
    {
      title: 'Constellations familiales systémiques',
      price: '120 CHF',
      duration: 'la séance',
      gradient: 'from-purple-600 to-violet-700',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      ),
    },
    {
      title: 'Communication animale',
      price: '90 CHF',
      duration: 'la séance',
      gradient: 'from-lavender-500 to-purple-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
        </svg>
      ),
    },
    {
      title: 'Thérapie Quantique',
      price: '140 CHF',
      duration: 'la séance',
      gradient: 'from-violet-600 to-purple-700',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="1.5" fill="currentColor" />
          <ellipse cx="12" cy="12" rx="9" ry="3.5" strokeWidth={1.5} />
          <ellipse cx="12" cy="12" rx="9" ry="3.5" strokeWidth={1.5} transform="rotate(60 12 12)" />
          <ellipse cx="12" cy="12" rx="9" ry="3.5" strokeWidth={1.5} transform="rotate(120 12 12)" />
        </svg>
      ),
    },
    {
      title: 'Clairconnaissance',
      price: '110 CHF',
      duration: 'la séance',
      gradient: 'from-purple-500 to-lavender-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
    },
    {
      title: 'Radiesthésie',
      price: '100 CHF',
      duration: 'la séance',
      gradient: 'from-lavender-600 to-violet-600',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <line x1="12" y1="2" x2="12" y2="15" strokeWidth={1.5} strokeLinecap="round" />
          <circle cx="12" cy="2" r="1" fill="currentColor" />
          <path d="M12 15 L9 20 L15 20 Z" fill="currentColor" stroke="currentColor" strokeWidth={1.5} strokeLinejoin="round" />
          <path d="M6 18 Q12 16 18 18" strokeWidth={1} strokeDasharray="2,2" opacity="0.5" />
        </svg>
      ),
    },
  ];

  return (
    <div className="w-full">
      {/* HERO SECTION */}
      <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
        {/* Multi-layer background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900 via-purple-700 to-lavender-600"></div>
        <div className="absolute inset-0 bg-gradient-to-tr from-violet-800/50 via-transparent to-purple-600/30"></div>
        
        {/* Animated background elements */}
        <AnimatedBackground opacity={0.6} />
        
        {/* Sacred geometry background */}
        <SacredGeometry opacity={0.06} />
        
        {/* Content */}
        <div className="relative z-10 text-center px-6 py-20 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-8 animate-fade-in text-glow">
            Tarifs
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-purple-100 leading-relaxed animate-fade-in-up font-light max-w-3xl mx-auto" style={{ animationDelay: '100ms' }}>
            Chaque accompagnement est proposé dans un cadre bienveillant, avec présence, écoute et respect de votre rythme.
          </p>
        </div>
      </section>

      {/* PRESTATIONS SECTION */}
      <section className="relative py-20 md:py-32 px-6 bg-gradient-to-b from-white via-purple-50/20 to-white">
        {/* Subtle background geometry */}
        <div className="absolute inset-0 overflow-hidden">
          <SacredGeometry opacity={0.015} />
        </div>
        
        <div className="relative z-10 max-w-5xl mx-auto">
          {/* Prestations */}
          <div className="space-y-8 md:space-y-12">
            {prestations.map((prestation, index) => (
              <div
                key={index}
                className="group bg-white/80 backdrop-blur-sm rounded-3xl p-8 md:p-12 shadow-soft hover:shadow-glow transition-all duration-700 border border-purple-100/50 animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="space-y-6">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
                    {/* Left: Icon + Title */}
                    <div className="flex-1 flex items-center gap-4">
                      <div className={`w-12 h-12 bg-gradient-to-br ${prestation.gradient} rounded-xl flex items-center justify-center text-white shadow-md group-hover:shadow-lg group-hover:scale-110 transition-all duration-500 flex-shrink-0`}>
                        {prestation.icon}
                      </div>
                      <h3 className="text-2xl md:text-3xl font-serif font-semibold text-purple-900 group-hover:text-purple-700 transition-colors duration-300">
                        {prestation.title}
                      </h3>
                    </div>
                    
                    {/* Right: Price */}
                    <div className="flex-shrink-0 text-center md:text-right">
                      <div className="inline-block px-6 py-4 bg-gradient-to-br from-purple-50 to-lavender-50 rounded-2xl border border-purple-200/50">
                        <div className="text-3xl md:text-4xl font-serif font-semibold text-purple-900 mb-1">
                          {prestation.price}
                        </div>
                        <div className="text-sm text-gray-500 font-light">
                          {prestation.duration} · hors taxe
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* CTA Button */}
                  <div className="flex justify-center md:justify-start">
                    <Link
                      to="/contact"
                      className="inline-block px-8 py-3 bg-gradient-to-r from-purple-600 to-lavender-600 text-white rounded-full hover:shadow-glow transition-all duration-300 font-medium text-base transform hover:scale-105"
                    >
                      Prendre rendez-vous
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Note */}
          <div className="mt-16 md:mt-20 text-center animate-fade-in-up" style={{ animationDelay: '600ms' }}>
            <div className="max-w-3xl mx-auto">
              <p className="text-gray-600 leading-relaxed text-base md:text-lg italic">
                Les séances se déroulent dans un cadre d'écoute et de respect. Pour toute question ou prise de rendez-vous, vous pouvez me contacter directement.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* QUOTE SECTION */}
      <section className="relative py-32 md:py-40 px-6 overflow-hidden">
        {/* Multi-layer background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-purple-800 via-purple-600 to-lavender-500"></div>
        <div className="absolute inset-0 bg-gradient-to-tl from-violet-700/40 via-transparent to-purple-700/30"></div>
        
        {/* Animated background elements */}
        <AnimatedBackground opacity={0.5} />
        
        {/* Sacred geometry */}
        <SacredGeometry opacity={0.05} />
        
        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-white leading-relaxed text-glow italic px-6">
            "Tout commence souvent par une écoute plus fine de ce qui ne se voit pas."
          </h2>
        </div>
      </section>

      {/* CONTACT CTA SECTION */}
      <section className="relative py-20 md:py-24 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-gray-600 text-lg md:text-xl mb-10 max-w-2xl mx-auto leading-relaxed">
            Je serais heureuse de vous accompagner dans votre cheminement.
          </p>
          <Link
            to="/contact"
            className="inline-block px-12 py-4 bg-gradient-to-r from-purple-600 to-lavender-600 text-white rounded-full hover:shadow-glow-lg transition-all duration-300 font-medium text-lg transform hover:scale-105"
          >
            Prendre rendez-vous
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Tarifs;
